module.exports = __webpack_public_path__ + "img/garage.89ef5657.svg";